module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-5.5229ae5e.jpg";